import React, { useContext } from 'react';

import { useIndex } from '../hooks';

import { IdentityContext } from './identity.provider';

export const AddressContext = React.createContext(null);

export function AddressProvider({ children }) {
  const { person } = useContext(IdentityContext);
  const { data, loading: addressLoading } = useIndex(
    'addresses',
    { person_id: person?.id },
    !person
  );

  if (addressLoading) {
    return <div>Loading address...</div>;
  }

  return (
    <AddressContext.Provider value={{ address: data[0] ?? {} }}>
      {children}
    </AddressContext.Provider>
  );
}
